import { Control, useController } from 'react-hook-form'
import { FieldWrapper, FormSection } from '../../../shared/ui'
import { FormInput } from '../../../shared/ui/controls/FormInput'
import { TradesMultiSelect } from './TradesMultiSelect'

interface TechnicianErrors {
  shiftStart?: string
  shiftEnd?: string
  breakStart?: string
}

interface Props {
  control: Control<any>
  errors?: TechnicianErrors
}

const WEEKDAYS = [
  { value: 1, label: 'Mo' },
  { value: 2, label: 'Di' },
  { value: 3, label: 'Mi' },
  { value: 4, label: 'Do' },
  { value: 5, label: 'Fr' },
  { value: 6, label: 'Sa' },
  { value: 7, label: 'So' },
]

function WorkingDaysToggle({ control }: { control: Control<any> }) {
  const { field, fieldState } = useController({
    name: 'technicianProfile.workingDays',
    control,
  })

  const selected: number[] = field.value ?? []

  const toggle = (day: number) => {
    const next = selected.includes(day)
      ? selected.filter((d) => d !== day)
      : [...selected, day].sort((a, b) => a - b)
    field.onChange(next)
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        {WEEKDAYS.map(({ value, label }) => {
          const isActive = selected.includes(value)
          return (
            <button
              key={value}
              type="button"
              onClick={() => toggle(value)}
              className={[
                'w-[44px] h-[44px] rounded-full font-[Roboto] text-[14px] font-bold transition-colors border',
                isActive
                  ? 'bg-[#004494] text-white border-[#004494]'
                  : 'bg-white text-[#004494] border-[#004494]',
              ].join(' ')}
            >
              {label}
            </button>
          )
        })}
      </div>
      {fieldState.error?.message && (
        <span className="font-['PT_Sans'] text-[14px] italic text-[#FB2424]">
          {fieldState.error.message}
        </span>
      )}
    </div>
  )
}

export function TechnicianFields({ control, errors }: Props) {
  return (
    <FormSection title="Techniker-Profil">
      <FieldWrapper label="Arbeitstage">
        <WorkingDaysToggle control={control} />
      </FieldWrapper>

      <FieldWrapper label="Schichtbeginn" error={errors?.shiftStart}>
        <FormInput
          name="technicianProfile.shiftStart"
          control={control}
          type="text"
          placeholder="HH:MM"
        />
      </FieldWrapper>

      <FieldWrapper label="Schichtende" error={errors?.shiftEnd}>
        <FormInput
          name="technicianProfile.shiftEnd"
          control={control}
          type="text"
          placeholder="HH:MM"
        />
      </FieldWrapper>

      <FieldWrapper label="Pausenbeginn" error={errors?.breakStart}>
        <FormInput
          name="technicianProfile.breakStart"
          control={control}
          type="text"
          placeholder="HH:MM"
        />
      </FieldWrapper>

      <FieldWrapper label="Gewerke">
        <TradesMultiSelect control={control} />
      </FieldWrapper>
    </FormSection>
  )
}
